/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cases_Col_Counterparty_DataInputs */

const en_cases_col_counterparty_data = /** @type {(inputs: Cases_Col_Counterparty_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Third party / debtor`)
};

const pt_br2_cases_col_counterparty_data = /** @type {(inputs: Cases_Col_Counterparty_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terceiro / devedor`)
};

/**
* | output |
* | --- |
* | "Third party / debtor" |
*
* @param {Cases_Col_Counterparty_DataInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const cases_col_counterparty_data = /** @type {((inputs?: Cases_Col_Counterparty_DataInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Col_Counterparty_DataInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cases_col_counterparty_data(inputs)
	return pt_br2_cases_col_counterparty_data(inputs)
});